export default "__VITE_ASSET__oLDjJSOp__"